// app/javascript/controllers/id_prefill_controller.js
import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static values = { profileId: String }
  static targets = ["fileLabel", "spinner", "error"]

  async extractAndFill(event) {
    const fileInput = event.target
    const file = fileInput.files[0]
    if (!file) return

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg']
    if (!allowedTypes.includes(file.type)) {
      this.showError("Type de fichier non supporté. Utilisez PDF, JPG ou PNG.")
      return
    }

    // type de document  - à utiliser dans le Reflex pour différencier les champs à préremplir
    const documentType = fileInput.dataset.documentType
    this.showLoading()
    this.clearError()

    try {
      // Convert to Base64
      const base64 = await this.fileToBase64(file)
      // Call Reflex with profile_id and Base64 data
      await this.stimulate('IdUploadReflex#prefill_from_id', this.profileIdValue, {
        id_file_base64: base64,
        document_type: documentType,
        file_name: file.name 
      })
    } catch (error) {
      console.error('Reflex error:', error)

      let message = ''

      if (error?.message) {
        message = error.message
      } else if (error?.data?.error) {
        message = error.data.error
      } else {
        message = "Une erreur technique est survenue"
      }

        this.showError(`Erreur lors de l'extraction${message ? ' : ' + message : ''}`)
      } finally {
        this.hideLoading()
    }
  }

  fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => {
        const base64 = reader.result.split(',')[1]
        resolve(base64)
      }
      reader.onerror = reject
      reader.readAsDataURL(file)
    })
  }

  showLoading() {
    this.spinnerTarget.classList.remove('d-none')
  }

  hideLoading() {
    this.spinnerTarget.classList.add('d-none')
  }

  showError(message) {
    this.errorTarget.innerText = message
    this.errorTarget.classList.remove('d-none')
  }

  clearError() {
    this.errorTarget.innerText = ''
    this.errorTarget.classList.add('d-none')
  }

  // Lifecycle: called after Reflex completes
  afterReflex() {
    // Optionally re-enable submit button or do other post‑extraction tasks
  }
}